import styled from 'styled-components';

export default function Separator(): JSX.Element {
  return (<Dot> • </Dot>);
}

const Dot = styled.span`
  color: ${({ theme }) => theme.colorGrey};
`;
